<template>
  <a-modal
          title="标准详情"
          okText="确认"
          cancelText="取消"
          width="700px"
          :visible="visible"
          :confirm-loading="confirmLoading"
          @ok="handleOk"
          @cancel="handleCancel"
  >
    <a-form-model ref="ruleForm" :model="formState" :rules="rules" :label-col="{span:8}" :wrapper-col="{span:16}">
      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="污染物CAS码" prop="badCas">
            <a-input v-model="formState.badCas"></a-input>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="污染物（中文名）" prop="badCn">
            <a-input v-model="formState.badCn"></a-input>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="污染物（英文名）" prop="badEn">
            <a-input v-model="formState.badEn"></a-input>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="农产品分类" prop="produceType">
            <a-input v-model="formState.produceType"></a-input>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="农产品名称" prop="produceName">
            <a-input v-model="formState.produceName"></a-input>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="主要用途" prop="mainUse">
            <a-input v-model="formState.mainUse"></a-input>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="每日允许摄入量" prop="dayLimit">
            <a-input v-model="formState.dayLimit"></a-input>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="残留物" prop="canliuwu">
            <a-input v-model="formState.canliuwu"></a-input>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="最大残留量" prop="canliuLimit">
            <a-input v-model="formState.canliuLimit"></a-input>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="单位" prop="unit">
            <a-input v-model="formState.unit"></a-input>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="监测方法" prop="checkFunc">
            <a-input v-model="formState.checkFunc"></a-input>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="备注" prop="remark">
            <a-input v-model="formState.remark"></a-input>
          </a-form-model-item>
        </a-col>
      </a-row>

    </a-form-model>

  </a-modal>
</template>

<script>


import {addorUpdateStdLimitItem as saveApi, getStdLimitItemById as initApi} from '../../../api/api'
import {FormRules} from 'antd-form-rules';

export default {
    name: "FormModel",
    props: {
        visible: {
            type: Boolean,
            default:
                false
        }
        ,
        param: {
            type: Object,
            default:
                () => {
                    return {}
                }
        }
    }
    ,
    data() {
        return {
            confirmLoading: false,
            formState: {
                bad_cas: '',
                bad_cn: '',
                bad_en: '',
                produce_type: '',
                produce_name: '',
                main_use: '',
                day_limit: '',
                canliuwu: '',
                canliu_limit: '',
                unit: '',
                check_func: '',
                remark: '',
            },
            rules: {
                badCas: FormRules.withName('污染物CAS码').string(1, 50).isRequired().create(),
                badCn: FormRules.withName('污染物（中文名）').string(1, 200).isRequired().create(),
                badEn: FormRules.withName('污染物（英文名）').string(1, 50).isRequired().create(),
                produceType: FormRules.withName('农产品分类').string(1, 50).isRequired().create(),
                produceName: FormRules.withName('农产品名称').string(1, 50).isRequired().create(),
                dayLimit: FormRules.withName('每日允许摄入量').number().create(),
                canliuLimit: FormRules.withName('最大残留量').number().isRequired().create(),
            },

        };
    }
    ,
    created() {
        this.initForm();
    }
    ,
    methods: {
        initForm() {
            if (this.param.id) {
                this.confirmLoading = true;
                initApi({id:this.param.id}).then((result => {
                    this.formState = result.data.data;
                    this.confirmLoading = false;
                })).catch(() => {
                    this.confirmLoading = false;
                });
            }
        }
        ,
        handleOk(e) {
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    this.confirmLoading = true;
                    this.formState.belongId=this.param.belongId;
                    saveApi(this.formState).then((result => {
                        this.confirmLoading = false;
                        this.$emit("addStdLimitItemModalClose", true)
                        this.$emit("update:visible", false)
                    })).catch(() => {
                        this.confirmLoading = false;
                    });
                } else {
                    return false;
                }
            });
        }
        ,
        handleCancel(e) {
            this.$emit("update:visible", false)
        }
        ,

    }
    ,
}
</script>

<style scoped lang="scss">

  /deep/ .ant-modal-body {
    /*height: 60vh;*/
    /*overflow-y: scroll;*/
  }

</style>